import { formatTime } from '../date-formatters/index.js';
/**
 * Formats a meeting body's recurring schedule into a readable string.
 *
 * @param recurringInterval - The recurring interval
 * @param recurringDay - The recurring day
 * @param recurringTime - The recurring time in HH:MM format
 * @returns A formatted string like "Monthly, Monday, 9:00 AM" or "N/A" if no schedule information
 */
export const formatMeetingBodySchedule = (recurringInterval, recurringDay, recurringTime) => {
    const parts = [];
    if (recurringInterval) {
        parts.push(recurringInterval);
    }
    if (recurringDay) {
        parts.push(recurringDay);
    }
    if (recurringTime) {
        const timeParts = recurringTime.split(':');
        if (timeParts.length === 2) {
            const hours = Number(timeParts[0]);
            const minutes = Number(timeParts[1]);
            if (!isNaN(hours) && !isNaN(minutes)) {
                const date = new Date(2000, 0, 1, hours, minutes, 0, 0);
                parts.push(formatTime(date));
            }
        }
    }
    return parts.length > 0 ? parts.join(', ') : 'N/A';
};
export const recurringIntervalOptions = [
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Annually', value: 'Annually' },
    { label: 'As Needed', value: 'As Needed' },
];
export const recurringDayOptions = [
    { label: 'Monday', value: 'Monday' },
    { label: 'Tuesday', value: 'Tuesday' },
    { label: 'Wednesday', value: 'Wednesday' },
    { label: 'Thursday', value: 'Thursday' },
    { label: 'Friday', value: 'Friday' },
    { label: 'Saturday', value: 'Saturday' },
    { label: 'Sunday', value: 'Sunday' },
];
export const EthnicityOptions = [
    'American Indian or Alaska Native',
    'Asian',
    'Black or African American',
    'Hispanic or Latino',
    'Middle Eastern or North African',
    'Native Hawaiian or Other Pacific Islander',
    'White',
    'Other',
    'Prefer not to answer',
];
export const ethnicityOptions = EthnicityOptions.map((e) => ({ label: e, value: e }));
